import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { useHttpClient, type SuccessResponse } from './httpClient';
import { storeToRefs } from 'pinia';
import type { Translations } from 'shared/translations/domain/translations';

export interface DeleteEntityApiOptions {
  url: string;
  translate: (translations: Translations) => DeleteEntityApiTranslations;
  processOk: (
    request: DeleteEntityRequest,
    response: Response,
  ) => Promise<DeleteEntitySuccessResponse>;
}

export interface DeleteEntityRequest {
  id: string;
}

export interface DeleteEntitySuccessResponse extends SuccessResponse {
  ok: true;
}

export interface DeleteEntityApiTranslations {
  title: string;
  error: string;
  statusCodes: Record<number, string> | undefined;
}

export function useDeleteEntityApi(options: DeleteEntityApiOptions) {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(action: DeleteEntityRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`${options.url}/${action.id}`), {
      method: 'DELETE',
      headers,
    });

    const text = options.translate(translations.value);

    const response = await httpClient.action<DeleteEntitySuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: (response) => options.processOk(action, response),
      overrideProblemDetails: (details) => {
        if (details.status === 409) {
          details.title = text.statusCodes?.[409] ?? text.error;
        }
      },
    });

    return response;
  }
}
